import { render, staticRenderFns } from "./ShopInfoPreview.vue?vue&type=template&id=bebb6260&scoped=true"
import script from "./ShopInfoPreview.vue?vue&type=script&lang=js"
export * from "./ShopInfoPreview.vue?vue&type=script&lang=js"
import style0 from "./ShopInfoPreview.vue?vue&type=style&index=0&id=bebb6260&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bebb6260",
  null
  
)

export default component.exports